"use strict";
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Core plugin logic that all plugins share.
 *
 * BasePlugin does not contain DOM rendering so it can be used for plugins
 * without a user interface.
 *
 * See `Plugin` for the extended version with Preact rendering for interfaces.
 */ var Translator = require("@uppy/utils/lib/Translator");
var BasePlugin = /*#__PURE__*/ function() {
    function BasePlugin(uppy, opts) {
        _class_call_check(this, BasePlugin);
        if (opts === void 0) {
            opts = {};
        }
        this.uppy = uppy;
        this.opts = opts;
    }
    _create_class(BasePlugin, [
        {
            key: "getPluginState",
            value: function getPluginState() {
                var plugins = this.uppy.getState().plugins;
                return plugins[this.id] || {};
            }
        },
        {
            key: "setPluginState",
            value: function setPluginState(update) {
                var plugins = this.uppy.getState().plugins;
                this.uppy.setState({
                    plugins: _object_spread_props(_object_spread({}, plugins), _define_property({}, this.id, _object_spread({}, plugins[this.id], update)))
                });
            }
        },
        {
            key: "setOptions",
            value: function setOptions(newOpts) {
                this.opts = _object_spread({}, this.opts, newOpts);
                this.setPluginState(); // so that UI re-renders with new options
                this.i18nInit();
            }
        },
        {
            key: "i18nInit",
            value: function i18nInit() {
                var translator = new Translator([
                    this.defaultLocale,
                    this.uppy.locale,
                    this.opts.locale
                ]);
                this.i18n = translator.translate.bind(translator);
                this.i18nArray = translator.translateArray.bind(translator);
                this.setPluginState(); // so that UI re-renders and we see the updated locale
            }
        },
        {
            /**
   * Extendable methods
   * ==================
   * These methods are here to serve as an overview of the extendable methods as well as
   * making them not conditional in use, such as `if (this.afterUpdate)`.
   */ // eslint-disable-next-line class-methods-use-this
            key: "addTarget",
            value: function addTarget() {
                throw new Error('Extend the addTarget method to add your plugin to another plugin\'s target');
            } // eslint-disable-next-line class-methods-use-this
        },
        {
            key: "install",
            value: function install() {} // eslint-disable-next-line class-methods-use-this
        },
        {
            key: "uninstall",
            value: function uninstall() {}
        },
        {
            /**
   * Called when plugin is mounted, whether in DOM or into another plugin.
   * Needed because sometimes plugins are mounted separately/after `install`,
   * so this.el and this.parent might not be available in `install`.
   * This is the case with @uppy/react plugins, for example.
   */ key: "render",
            value: function render() {
                throw new Error('Extend the render method to add your plugin to a DOM element');
            } // TODO: remove in the next major version. It's not feasible to
        },
        {
            // try to use plugins with other frameworks.
            // eslint-disable-next-line class-methods-use-this
            key: "update",
            value: function update() {} // Called after every state update, after everything's mounted. Debounced.
        },
        {
            // eslint-disable-next-line class-methods-use-this
            key: "afterUpdate",
            value: function afterUpdate() {}
        }
    ]);
    return BasePlugin;
}();
module.exports = BasePlugin;
